import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Header } from 'modules/styled';
import { connect } from 'react-redux';

class InviteModalTitle extends Component {
  static propTypes = {
    community: PropTypes.object,
  };

  submit = async () => ({});

  render() {
    const { community } = this.props;
    const activeCommunity = community.communities?.[community]?.active?.name;
    return (
      <Row
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          flex: 1,
        }}
      >
        <Header sx={{ flexShrink: 1 }}>Invite Friends To {activeCommunity}</Header>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  community: state.community,
  inviteList: state?.admin?.inviteList || {},
});

const mapDispatchToProps = () => ({
  // actions: bindActionCreators(
  //   {
  //     // getInvites
  //   },
  //   dispatch
  // )
});

export default connect(mapStateToProps, mapDispatchToProps)(InviteModalTitle);
